import { localeNamespace } from '@internal/utils/machine/i18n/Locale';
import {
    AvailableMachineTypes,
    MachineType,
} from '@internal/utils/machine/MachineType';
import { getMediaUrl } from '@internal/utils/media/getMediaSrc';
import { translations } from 'i18n/translations';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { MachinePlaceholderImageMapper } from 'utils/machine/placeholder/MachinePlaceholderImageMapper';
import { useMachineTypeName } from 'utils/machine/useMachineTypeName';
import { SelectFilterOption } from '../RemoteAutocomplete/SelectFilterOption';

export const useMachineTypeOptions = () => {
    const { getMachineTypeName } = useMachineTypeName();
    const { t } = useTranslation(localeNamespace.common);

    return useMemo<SelectFilterOption[]>(() => {
        const machineTypes = Object.values(AvailableMachineTypes);
        const popularMachineTypes = [
            MachineType.TRACTOR,
            MachineType.COMBINE_HARVESTER,
            MachineType.BALER,
            MachineType.POTATO_HARVESTER,
            MachineType.TELEHANDLER,
        ];

        const popularMachineType = popularMachineTypes.map(
            (machineType): SelectFilterOption => ({
                label: getMachineTypeName(machineType, 'plural'),
                imageUrl: getMediaUrl(
                    MachinePlaceholderImageMapper(machineType, 'image'),
                ),
                value: machineType,
                group: t(translations.searchResultsFiltersLocationPopularLabel),
            }),
        );

        const otherMachineType = machineTypes
            .filter(machineType => !popularMachineTypes.includes(machineType))
            .map(
                (machineType): SelectFilterOption => ({
                    label: getMachineTypeName(machineType, 'plural'),
                    value: machineType,
                    group: t(
                        translations.searchResultsFiltersLocationOtherMachineryLabel,
                    ),
                }),
            )
            .sort((a, b) => (a.label > b.label ? 1 : -1));

        return [...popularMachineType, ...otherMachineType];
    }, [getMachineTypeName, t]);
};
